/* eslint-disable @typescript-eslint/no-explicit-any -- existing annotations; retyping would change compile behavior */
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Popover from '@mui/material/Popover';
import DropdownItem from '../DropdownItem';
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import CreateCase from 'views/Dashboards-B2B/components/BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/components/CreateCase/CreateCase';
import * as S from '../../Dashboard.styled';
import { ReactComponent as CrossSimpleIcon } from 'assets/icons/cross-simple.svg';
import { Fade, Modal } from '@mui/material';
import IconBtn from 'components/common/IconBtn';
import styles from '../BACKOFFICEFLOW/MYCLIENTS/components/dashboard/salesOnboarding/ClientProfile.module.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';

type SelectCaseDropdownProps = {
    selectedCase: string;
    mobile?: boolean;
    handleSelectedCase: (selectedCase: string) => void;
    dropdownMenuPrograms: any;
    clientProfile?: boolean;
    customStyleForSearchbar?: boolean;
    agreementPage?: boolean;
};

const SelectCaseDropdown = ({
    selectedCase,
    mobile,
    handleSelectedCase,
    dropdownMenuPrograms,
    clientProfile,
    customStyleForSearchbar,
    agreementPage,
}: SelectCaseDropdownProps) => {
    const { language_setting: language } = useSelector((state: RootState) => state.user.entity);
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const location = useLocation();
    const [modalOpen, setModalOpen] = useState(false);
    const [clientView, setClientView] = useState<boolean>(false);

    useEffect(() => {
        location.pathname.includes('client-profile') ? setClientView(true) : setClientView(false);
    }, [location.pathname]);

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const handleOptionClick = (e: React.MouseEvent<HTMLElement>, selectedCase: any) => {
        e.stopPropagation();
        handleSelectedCase(selectedCase.name);
        selectedCase.onClick();
        handleClose();
    };

    const handleModalOpen = async (e: React.MouseEvent<HTMLElement>) => {
        e.stopPropagation();
        setModalOpen(true);
    };
    const handleModalClose = () => setModalOpen(false);

    return (
        <>
            <S.LeftDropdown
                customStyleForSearchbar={customStyleForSearchbar}
                clientProfile={clientProfile}
                mobile={mobile}
                agreementPage={agreementPage}
                isActive={!!anchorEl}
                onClick={(event) => {
                    handleClick(event);
                }}
            >
                <S.SelectionContainer>{selectedCase}</S.SelectionContainer>
                <S.DropdownIcon />
            </S.LeftDropdown>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                marginThreshold={0}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                slotProps={{
                    paper: {
                        sx: {
                            overflow: 'visible',
                            mt: '8px',
                            minWidth: '7rem',
                            padding: '0',
                            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.09)',
                        },
                    },
                }}
                transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            >
                <S.DropDownMenu>
                    {clientView && (
                        <DropdownItem
                            style={{
                                color: '#1DD75BFF',
                                display: 'flex',
                                justifyContent: 'space-between',
                            }}
                            onClick={(e) => handleModalOpen(e)}
                        >
                            {t('createNewCase', { lng: language })}
                            <PlusIcon fill="#1DD75BFF" />
                        </DropdownItem>
                    )}
                    {dropdownMenuPrograms.map((option: any, i: number) => {
                        return (
                            <DropdownItem
                                style={{ display: 'inline-block' }}
                                key={i}
                                onClick={(e) => handleOptionClick(e, option)}
                            >
                                {option.name}
                            </DropdownItem>
                        );
                    })}
                </S.DropDownMenu>
            </Popover>
            <Modal open={modalOpen} onClose={handleModalClose}>
                <Fade in={modalOpen}>
                    <div className={styles['modal-wrapper']}>
                        <div className={styles.modal}>
                            <CreateCase closeModal={handleModalClose} />
                            <div className={styles['modal__btn-wrapper']}>
                                <IconBtn
                                    style={{ height: '24px', width: '24px' }}
                                    onClick={handleModalClose}
                                >
                                    <CrossSimpleIcon className={styles['close-icon']} />
                                </IconBtn>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </>
    );
};

export default SelectCaseDropdown;
